import React from 'react';
import App from '@app';
import { Body, PageHeader } from '@components';
import ProcessosIndicadores from './ProcessosIndicadores';
import { reset } from '@ducks/logsTempos';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { capitalizeFirst } from '@utils/';

const processType = { INDICADORES: 'INDICADORES' };

export default function ProcessoWeb() {
  const { tipoProcesso } = useParams();
  const dispatch = useDispatch();

  const handleProcessType = () => {
    switch (tipoProcesso) {
      case processType.INDICADORES:
        return <ProcessosIndicadores />;
      default:
        return;
    }
  };

  return (
    <App>
      <Body>
        <PageHeader
          title={`Processos Web - ${capitalizeFirst(tipoProcesso)}`}
          onBack={() => {
            dispatch(reset());
            window.history.back();
          }}
        >
          {handleProcessType()}
        </PageHeader>
      </Body>
    </App>
  );
}
